import React from "react";
import {
  Button,
  Card,
  CardBody, Col, CustomInput,
  Form, Input, Label, Row,
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import GroupSelect from "../../elements/groups/GroupSelect";
import DimensionsMultiSelect from "../../elements/dimensions/multi-select/dimensionsMultiSelect";
import TagSelect from "../../elements/tags/TagSelect";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import {browserHistory, useRouterStore} from "mobx-state-router";
import CodeTypeSelect from "../../elements/codeTypes/CodeTypeSelect";
import {defaultStyles, FileIcon} from "react-file-icon";
import PdfQuickPreview from "../../../utils/PdfQuickPreview";

const CreateMediaFileForm = observer(({createMediaFileState}) => {
  const intl = useIntl();
  const routerStore = useRouterStore();

  const hiddenFileInput = React.useRef(null);
  const handleImageUploadClick = event => {
    hiddenFileInput.current.click();
  };
  const renderFileIcon = (fileFormat) => {
    return(
      <Col>
        <Col sm={1}>
        </Col>
        <Col sm={2} style={{width: "100px"}}> <FileIcon extension={fileFormat} {...defaultStyles[fileFormat]}/></Col>
        <Col sm={1}>
        </Col>
      </Col>
    )};

  return (
    <Card>
      <CardBody>
        <Form>
          <Row className="p-1">
            <Label sm={1} className="text-sm-right"><FormattedMessage
              id="createQr.groups.defaultMessage"/></Label>
            <Col sm={3}>
              <GroupSelect groupSelectStore={createMediaFileState.groupSelectStore}/>
            </Col>
            <Col sm={1} className="form-col-center-margin">
              <CustomInput
                type="switch"
                id="isGroupGlobal"
                name="isGroupGlobal"
                label={intl.formatMessage({id: 'qrDesign.create.groupOnly.defaultMessage',defaultMessage:"Only"})}
                checked={createMediaFileState?.isExclusivelyGroupOwned}
                onChange={() => createMediaFileState.toggleIsExclusivelyGroupOwned()}
              />
            </Col>
            {createMediaFileState?.dimensionsMultiSelectStore?.dimensionStore?.dimensionsEnabled && <Col sm={2} className="form-col-center-margin">
              <CustomInput
                type="switch"
                id="isDimensionAll"
                name="isDimensionAll"
                label={createMediaFileState?.dimensionsMultiSelectStore?.getLabelsWithPrefix(intl.formatMessage({id: 'qrDesign.create.dimensionAll.defaultMessage'}))}
                checked={createMediaFileState?.dimensionAll}
                onChange={() => createMediaFileState.toggleDimensionAll()}
              />
            </Col>}
            {createMediaFileState?.dimensionsMultiSelectStore?.dimensionStore?.dimensionsEnabled && createMediaFileState.isDimensionSelectVisible && <>
              <Col>
                <DimensionsMultiSelect dimensionMultiSelectState={createMediaFileState.dimensionsMultiSelectStore}/>
              </Col>
            </>}
          </Row>
          <Row className="p-1 mt-2">
            <Label sm={1} className="text-sm-right"><FormattedMessage id="createQr.tags.defaultMessage"/></Label>
            <Col>
              <TagSelect tagSelectStore={createMediaFileState?.tagSelectStore}/>
            </Col>
          </Row>
          <Row className="p-1 mt-2">

            <Col sm={1}></Col>
            <Col sm={2}>
              <Button id="uploadbg-btn" onClick={handleImageUploadClick}>
                <FormattedMessage id="mediaFile.upload.defaultMessage"/>
              </Button>

              <input
                type="file"
                name="FileImage"
                style={{display: "none"}}
                ref={hiddenFileInput}
                onChange={(event) => {
                  const selectedFile = event.target.files[0];
                  if (selectedFile) {
                    createMediaFileState.setSelectedImage(selectedFile, false,);
                    event.target.value = ''
                  }
                }}
              ></input>

            </Col>

            <Col>
              {createMediaFileState.usageIsContent()&&
              <>
                {/*"defaultMessage": "Accepted formats: audio/video (mp3, mp4, wav, mov), documents (doc, docx, xls, xlsx, csv, txt, ppt, pptx, pdf),\nimages (jpg, jpeg, png, gif, tiff, svg, eps, pdf), others ( JSON, HTML, XML)",*/}
                <FormattedMessage id="mediaFile.mediaFileCreateForm.acceptedContentFormats.defaultMessage"/>
                <br/> <FormattedMessage id="mediaFile.mediaFileCreateForm.acceptedContentImageSize.defaultMessage"/>
              </>
              }
              {createMediaFileState.usageIsQRImage() &&
                <>
                <FormattedMessage id="mediaFile.mediaFileCreateForm.acceptedQrImageFormats.defaultMessage"/>
                <br/> <FormattedMessage id="mediaFile.mediaFileCreateForm.acceptedQrImageSize.defaultMessage"/>
              </>
              }

            </Col>
            {/*<Col sm={1}>*/}
            {createMediaFileState.base64NonBrowserConvertedFile &&
              <Col>
                <Col sm={1}></Col>
                <Col sm={2}>
                  <img
                    style={{width: "150px"}}
                    src={createMediaFileState.base64NonBrowserConvertedFile}
                    alt="EPS Preview"
                  />
                </Col>
                <Col sm={1}></Col>
              </Col>
            }
            {createMediaFileState.shouldRenderFileImage() &&
              <Col>
                <Col sm={1}>
                </Col>
                <Col sm={2}>
                  <img
                    style={{width: "150px"}}
                    src={createMediaFileState.imagePreviewSrc()}
                  />
                </Col>
                <Col sm={1}>
                  {/*<div>*/}
                  {/*<FontAwesomeIcon onClick={createMediaFileState.removeFile} style={{cursor: "pointer"}} icon={faTrash}*/}
                  {/*                 className="align-middle"/>*/}
                  {/*</div>*/}
                </Col>
              </Col>
            }
            {createMediaFileState.shouldRenderFileIcon() && renderFileIcon(createMediaFileState.mediaFile?.fileFormat)
              }
            {createMediaFileState.shouldRenderStagedPDFToUpload() &&
              createMediaFileState.fileForS3Upload?.type === "application/pdf" && (
                <Col sm={6}>
                <div style={{width: "100%", maxHeight: "70vh", overflow: "auto", display: "inline-block"}}>
                  <PdfQuickPreview file={createMediaFileState.fileForS3Upload}/>
                </div>
                </Col>
              )
            }
            {/*</Col>*/}
          </Row>

          <Row className="p-1">
            <Col sm={1}></Col>
            <Label sm={1} >Usage</Label>
            <Col sm={1} className="form-col-center-margin">
              <Input name="content"
                     type="radio"
                     id="content"
                     checked={createMediaFileState.usageIsContent()}
                     onClick={() => {
                       createMediaFileState.setUsage("content")
                     }}
              />
              <Label check>
                <FormattedMessage id="mediaFile.content.defaultMessage"/>
              </Label>
            </Col>
            <Col sm={1} className="form-col-center-margin">
              <Input name="qrImage"
                     type="radio"
                     id="qrImage"
                     checked={createMediaFileState.usageIsQRImage()}
                     onClick={() => {
                       createMediaFileState.setUsage("qrImage")
                     }}
              />
              <Label check>
                <FormattedMessage id="mediaFile.qrImage.defaultMessage"/>
              </Label>
            </Col>
          </Row>

          <Row className="p-1">
            <Label sm={1} className="text-sm-right"><FormattedMessage id="mediaFile.name.defaultMessage"/></Label>
            <Col sm={11}>
              <div className="custom-controls-stacked">
                <Input
                  // plaintext
                  placeholder="Will use file name if left blank"
                  id="name"
                  name="name"
                  // style={{color:"blue",fontStyle: "italic"}}
                  onChange={(data)=>{createMediaFileState.mediaFile.updateInput("name",data)}}
                  value={createMediaFileState.mediaFile.name}
                />
              </div>
            </Col>
          </Row>

          <Row className="p-1">
            <Col sm={2}>
              <Button id="back-btn" color="secondary" onClick={browserHistory.goBack}><FormattedMessage id="mediaFile.back.defaultMessage"/></Button>
            </Col>

            <Col sm={10} className="text-right">

              <Button
                disabled={createMediaFileState.isLoading}
                id="save-btn"
                outline color="primary"
                // disabled={createCodeViewState.isSaveDisabled()}
                      onClick={async () => {
                        if (!createMediaFileState.mediaFile.name) {
                          createMediaFileState.mediaFile.updateName(createMediaFileState.fileForS3Upload.name)
                        }
                        const res = await createMediaFileState.createNewLocationUploadFile()
                        if (res) {
                          routerStore.goTo('editMediaFile', {
                            params: {uuid: res.uuid}
                          })
                        }else{
                          console.log("failed to save media file")
                        }
                      }}
              ><FormattedMessage id="mediaFile.save.defaultMessage"/></Button>
            </Col>
            {/*{createCodeViewState.status !== "PUBLISHED" &&*/}
            {/*  <Col sm={3} className="text-right">*/}
            {/*    <Button color="primary" disabled={createCodeViewState.isLoading}*/}
            {/*            onClick={async () => {*/}
            {/*              createCodeViewState.statusViewState.setStatus("PUBLISHED")*/}
            {/*              createCodeViewState.setStatus("PUBLISHED")*/}
            {/*              const res = await createCodeViewState.saveNew()*/}

            {/*            }}>Publish On Save</Button>*/}
            {/*  </Col>*/}
            {/*}*/}
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
})

export default CreateMediaFileForm;
